import { InterventionAction } from 'graphql-common';
import FieldNames from '@lib/enums/fieldNames/interventionActionFieldNames';
import { getInterventionActionStatusOption } from '@lib/utils/status';
import { getTimeFromMinutesCount } from '@lib/utils/getTimeFromMinutesCount';
import { dateOnlyToDatePickerValue } from '@lib/utils/dateTimeHelpers';

export const DEFAULT_VALUES = {
  [FieldNames.DetailsTitle]: null,
  [FieldNames.Status]: null,
  [FieldNames.Description]: null,
  [FieldNames.AttachmentsAttached]: [],
  [FieldNames.AssignAction]: null,
  [FieldNames.Assignee]: null,
  [FieldNames.AssigneeList]: null,
  [FieldNames.TimingTitle]: null,
  [FieldNames.EstimatedTime]: null,
  [FieldNames.EstimatedDate]: null,
  [FieldNames.LogisticTime]: null,
  [FieldNames.DurationTime]: null,
};

export default function getInterventionDefaultValuesFromQueryData(
  data: InterventionAction,
  assigneeIds: { id: string }[],
) {
  return {
    ...DEFAULT_VALUES,
    [FieldNames.Description]: data?.text || '',
    [FieldNames.AttachmentsAttached]: data?.attachmentsAttached || [],
    [FieldNames.Status]: data?.status
      ? getInterventionActionStatusOption(data.status)
      : null,
    [FieldNames.Assignee]:
      assigneeIds?.length > 0
        ? assigneeIds.map(({ id }) => ({ value: id }))
        : null,
    [FieldNames.EstimatedTime]: data?.estimatedTime
      ? getTimeFromMinutesCount(data.estimatedTime)
      : '',
    [FieldNames.EstimatedDate]: data?.estimatedDate
      ? dateOnlyToDatePickerValue(data.estimatedDate)
      : '',
    [FieldNames.LogisticTime]: data?.logisticTime
      ? getTimeFromMinutesCount(data.logisticTime)
      : '',
    [FieldNames.DurationTime]: data?.durationTime
      ? getTimeFromMinutesCount(data.durationTime)
      : '',
    // Custom renders
  };
}
